import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import * as React from "react";
import { setSnackbarMsg, setSnackbarToggled } from "../services/common/common";

type SnackbarAction = "clickaway" | "timeout";

export function SimpleSnackbar() {
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (
        event: React.SyntheticEvent | Event,
        reason?: SnackbarAction
    ) => {
        if (reason === "clickaway") {
            return;
        }

        setOpen(false);
    };

    const action = (
        <React.Fragment>
            <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>
            <Button onClick={handleClick}>Open simple snackbar</Button>
            <Snackbar
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
                message="Note archived"
                action={action}
            />
        </>
    );
}

interface SnackbarProps {
    open: boolean;
    msg: string;
    expireDuration?: number;
}
export const HermesSnackbar: React.FC<SnackbarProps> = (
    props: SnackbarProps
) => {
    const expireDuration = props.expireDuration || 4000;

    const handleClose = (
        event: React.SyntheticEvent | Event,
        reason?: SnackbarAction
    ) => {
        setSnackbarToggled(false);
        setSnackbarMsg("");
        if (reason === "clickaway") {
            return;
        }
    };

    // TODO: keep below comment for UNDO 対応
    const action = (
        <React.Fragment>
            {/* <Button color="secondary" size="small" onClick={handleClose}>
                UNDO
            </Button> */}
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <Snackbar
            open={props.open}
            autoHideDuration={expireDuration}
            onClose={handleClose}
            message={props.msg}
            action={action}
        />
    );
};
